import React from 'react';
import classNames from 'classnames/bind';
import { DimmedHeader, DimmedFooter } from '@/components/CustomTravel/DimmedPopup';
import { GroupTypeList } from './GroupTypeList';
import ConditionalField from '@/components/CustomTravel/ServiceFormFields/ConditionalField';

import ServiceForm from '@/components/CustomTravel/ServiceForm';
import { CustomTravelParamType, CustomTravelEstimatePopupStep } from '@/components/CustomTravel/EstimatePopup';
import { CustomOption } from '@/types/apollo';
import { GroupType } from '@/atoms/customTravelFormState';
import styles from './SelectGroupTypeForm.module.scss';
import usePopupHandler from '@/hooks/custom/usePopupHandler';

const cx = classNames.bind(styles);

interface SelectGroupTypeFormProps {
  customOptions: CustomOption[];
  externalValues?: { groupType: GroupType & { etcName?: string } };
}

const SelectGroupTypeForm: React.FC<SelectGroupTypeFormProps> = ({ customOptions, externalValues }) => {
  const { handleBack, currentType, onSubmitNextStep } = usePopupHandler();
  const isAdvisorType = currentType === CustomTravelParamType.ADVISOR_TYPE;

  const handleSubmit = (value: any) => {
    const filteredCustomOption = customOptions.filter(({ groupType }) => value?.groupType?.code === groupType)[0];
    if (filteredCustomOption) {
      onSubmitNextStep(
        {
          groupType: {
            code: filteredCustomOption?.groupType,
            name: value?.groupType.etcName || filteredCustomOption?.groupName,
          },
        },
        isAdvisorType ? CustomTravelEstimatePopupStep.SelectDuration : CustomTravelEstimatePopupStep.SelectLocation,
        { type: currentType },
      );
    }
  };

  return (
    <ServiceForm onSubmit={handleSubmit} externalValues={externalValues}>
      <div className={cx('GroupType')} data-event-nlog="imp" data-event-area-code="customtravel.popup.grouptype">
        <DimmedHeader>
          {!isAdvisorType && (
            <span className={cx('page')}>
              <span className={cx('blind')}>현재</span>
              <b>{'1'}</b>
              <span className={cx('blind')}>전체</span>
              <span>{'5'}</span>
            </span>
          )}
          <span className={cx('title')}>단체 유형</span>
        </DimmedHeader>
        <GroupTypeList customOptions={customOptions} />
        <DimmedFooter>
          <div className={cx('progress')}>
            <button
              type="button"
              className={cx('prev')}
              onClick={handleBack(CustomTravelEstimatePopupStep.SelectCustomType)}
              data-event-nlog="click"
              data-event-area-code="cus.advgrouptypebackpage"
            >
              이전
            </button>
            <ConditionalField targetFieldName="groupType">
              {(value: { code: string; etcName: string }) => {
                // 기타 선택시 값이 입력되어야함
                const existChecked = value?.code === 'etc' ? !!value?.etcName : !!value?.code;
                return (
                  <button
                    type="submit"
                    className={cx('next')}
                    disabled={!existChecked}
                    data-event-nlog="click"
                    data-event-area-code="cus.advgrouptypenextpage"
                  >
                    다음
                  </button>
                );
              }}
            </ConditionalField>
          </div>
        </DimmedFooter>
      </div>
    </ServiceForm>
  );
};

export default SelectGroupTypeForm;
